/**
 * How late a survey occurrence was filled in, as a count and as words.
 *
 * ONE rule for the client's Ankiety pane and the review inbox on `/raporty`, which used to count it
 * twice — one from `completedAt`, one from `submittedAt`, under two sets of copy. The count is whole
 * days from the cycle's civil day (UTC midnight, because a cycle date carries no zone) to the
 * instant it was filled; a submission on its own cycle day is not late.
 *
 * Pure: no React, no DOM, no query hook, no i18next — `t` arrives as a parameter.
 */

import { MS_PER_DAY } from '~/shared/lib/calendarDate';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Whole days after `cycleDate` the occurrence was filled at, or `null` when not after it at all. */
export function daysLate(cycleDate: string, filledAt: Date): number | null {
  const cycle = Date.parse(`${cycleDate}T00:00:00Z`);
  if (Number.isNaN(cycle) || Number.isNaN(filledAt.getTime())) return null;
  const days = Math.floor((filledAt.getTime() - cycle) / MS_PER_DAY);
  return days > 0 ? days : null;
}

/** „2 dni po terminie", or „po terminie" when the backend stamped it late and the days are unknown. */
export function latenessLabel(days: number | null, t: Translate): string {
  return days === null
    ? t('web:surveyReport.latenessPlain')
    : t('web:surveyReport.lateness', { count: days });
}
